const styles = theme => ({
  root: {
    marginLeft: 100,
    marginTop: 191,
    color: theme.color.tundora,
    [theme.breakpoints.down(700)]: {
      marginLeft: 30,
      marginRight: 30,
      marginTop: 20,
    },
  },
  textNote: {
    fontSize: 14,
    textTransform: 'uppercase',
    lineHeight: '20px',
    fontWeight: 500,
    letterSpacing: 2,
    margin: 0,
  },
  title: {
    fontSize: 48,
    margin: 0,
    [theme.breakpoints.down(700)]: {
      fontSize: 24,
    },
  },

  textDescription: {
    fontSize: 14,
    width: '100%',
    maxWidth: 384,
    marginBottom: 23,
  },
});

export default styles;
